var React = require('react');

function SearchMobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M31.47 23.812c2.45 0 4.728-.74 6.621-2.01l7.348 7.35a1.5 1.5 0 102.122-2.12l-7.202-7.204a11.862 11.862 0 003.017-7.922C43.376 5.33 38.046 0 31.47 0c-6.576 0-11.906 5.33-11.906 11.906 0 6.576 5.33 11.906 11.906 11.906zM31.47 3a8.905 8.905 0 00-8.906 8.906 8.905 8.905 0 008.906 8.906 8.87 8.87 0 005.831-2.174 8.885 8.885 0 003.075-6.732A8.905 8.905 0 0031.47 3z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.5 6A4.5 4.5 0 003 10.5V36h21v-9.401a1.5 1.5 0 113 0V40.5a7.5 7.5 0 01-7.5 7.5h-12A7.5 7.5 0 010 40.5v-30A7.5 7.5 0 017.5 3h8.785a1.5 1.5 0 010 3H7.5zM3 40.5V39h21v1.5a4.5 4.5 0 01-4.5 4.5h-12A4.5 4.5 0 013 40.5z","key":1})]);
}

SearchMobile.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = SearchMobile;

SearchMobile.default = SearchMobile;
